<svg width="70" height="37" viewBox="0 0 70 37" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1016_3977)">
<path d="M46.2876 32.4476L55.8943 22.94L46.4087 13.5522L46.4208 13.5402L36.3962 3.61893L35.7481 2.98349L35.427 2.66577L32.3984 -0.307617L8.90864 22.94L18.5153 32.4476H-0.195312V35.9665H70.8192V32.4476H46.2876ZM31.1446 27.43L26.8622 23.1917L28.752 21.3214L31.1446 23.6893L36.0267 18.8276L37.9165 20.6979L31.1446 27.43Z" fill="#280D0A"/>
</g>
<defs>
<clipPath id="clip0_1016_3977">
<rect width="70" height="37" fill="white"/>
</clipPath>
</defs>
</svg>
